// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const withIsVisible = require('client-v2/common/components/is-visible')
const collectionSelectModalSelectors = require('client-v2/common/containers/collection-select-modal/selectors')
// Sibling imports
const actions = require('./actions')
const selectors = require('./selectors')

function mapStateToProps() {
  const promoSelector = selectors.createPromoSelector()
  return function (state) {
    if (!selectors.isVisible(state)) {
      return { isVisible: false }
    }
    return {
      // Flags
      isAddedToProfile: selectors.isAddedToProfile(state),
      isArticleFailed: selectors.isArticleFailed(state),
      isArticleLoading: selectors.isArticleLoading(state),
      isArticleMixed: selectors.isArticleMixed(state),
      isCollectionsModalVisible: selectors.isCollectionsModalVisible(state),
      isSubmitDisabled: !selectors.isArticleLoaded(state),
      isSubmitPending: selectors.isSubmitPending(state),
      isUrlInvalid: selectors.isUrlInvalid(state),
      isVisible: true,
      // Values
      article: selectors.article(state),
      collectionsModalCount: collectionSelectModalSelectors.filteredCollectionsCount(state),
      errorMessage: selectors.errorMessage(state),
      postHref: selectors.postHref(state),
      promo: promoSelector(state),
      url: selectors.url(state)
    }
  }
}

const mapDispatchToProps = {
  fetchArticle: actions.fetchArticle,
  onDismiss: actions.hide,
  onRetryClick: actions.retryFetch,
  onUnmixPromptConfirm: actions.confirmUnmix,
  onUrlSubmit: actions.submit,
  onUrlTextChange: actions.setUrlText
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    withImmutableToJS(
      require('./component-dumb')
    )
  )
)
